import initVueApp from "@/core.js";
const component = require(`./../views/FeaturedCollection.vue`).default;
initVueApp(component);
